import { useTranslation } from 'react-i18next'
import { useCustomChartContext } from './CustomChartState'
import { MultipleChoiceButton } from './MultipleChoiceButton'
import { dataTypes } from './helpers'

export const DataTypePickerPreview = () => {
  const {
    state: { dataType },
  } = useCustomChartContext()
  if (!dataType) return null
  const dt = dataTypes.find((d) => d.id === dataType)
  if (!dt) return null
  return <div className="pl-3 text-indigo-700">{dt.name}</div>
}

export const DataTypePicker = () => {
  const { t } = useTranslation()
  const {
    state: { dataType, current },
    dispatch,
  } = useCustomChartContext()

  return (
    <div className="flex-1 h-full flex flex-col justify-between">
      <div className="flex-1 space-y-6">
        <h3 className="font-medium text-lg">
          {t('custom_widgets.step_1_title')}
        </h3>
        <div className="grid grid-cols-3 gap-8">
          {dataTypes.map((dt) => (
            <MultipleChoiceButton
              key={dt.id}
              onClick={() => {
                dispatch({
                  type: 'SET_DATA_TYPE',
                  payload: { dataType: dt.id },
                })
                dispatch({
                  type: 'SET_CURRENT',
                  payload: { current: current + 1 },
                })
              }}
              selected={dt.id === dataType}
            >
              <div className="space-y-0.5 flex-1 text-left">
                <h4 className="font-semibold leading-tight">{dt.name}</h4>
                <p className="text-sm text-gray-500">{dt.description}</p>
              </div>
              <div className="flex justify-end w-full">{dt.icon}</div>
            </MultipleChoiceButton>
          ))}
        </div>
      </div>
    </div>
  )
}
